import { ApiRequestError } from "@nexxt/api-client";
import { Button, EmptyState } from "@nexxt/ui";
import { useRouter } from "@tanstack/react-router";
import { errorText } from "../errors";
import { m } from "../paraglide/messages.js";

/** What happened, and the request id to quote to support (design-system.md §4.12). */
export function RouteError({ error }: { error: unknown }) {
  const router = useRouter();
  // 401: the browser is already on its way to the login
  if (error instanceof ApiRequestError && error.status === 401) return null;
  const notFound = error instanceof ApiRequestError && error.status === 404;
  return (
    <EmptyState title={notFound ? m.error_not_found() : m.error_title()}>
      <p>{errorText(error)}</p>
      <Button className="mt-4" onClick={() => void router.invalidate()}>
        {m.try_again()}
      </Button>
    </EmptyState>
  );
}
